import { render, staticRenderFns } from "./NotificationLoader.vue?vue&type=template&id=06d51ec2&"
import script from "./NotificationLoader.vue?vue&type=script&lang=js&"
export * from "./NotificationLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports